<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Dettaglio rilievo">
                <div ngbDropdown class="d-inline-block">
                    <button type="button" class="btn btn-outline-primary mt-3 mr-2" ngbDropdownToggle id="rilievoDettaglioAzioni">
                        Azioni
                        <app-toolkit-bl-icon icon="arrow-down-triangle" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="rilievoDettaglioAzioni">
                        <button ngbDropdownItem [routerLink]="['..']">
                            <app-toolkit-bl-icon icon="arrow-left" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                            Torna indietro
                        </button>
                        <button ngbDropdownItem (click)="goToModifica()">
                            <app-toolkit-bl-icon icon="pencil" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                            Modifica
                        </button>
                        <button ngbDropdownItem (click)="deleteRilievo()">
                            <app-toolkit-bl-icon icon="close" cssClass="icon icon-sm icon-danger"></app-toolkit-bl-icon>
                            Elimina
                        </button>
                    </div>
                </div>
            </app-toolkit-page-title>
            <ngb-accordion aria-busy="true" #acc="ngbAccordion" activeIds="tab-1">
                <ngb-panel id="tab-1" title="Opere associate">
                    <ng-template ngbPanelContent>
                        <app-toolkit-rilievo-tab-opere-associate [canEdit]="false" [items]="opereAssociateList" [formGroup]="criteriaForm" [datalist]="datalist"></app-toolkit-rilievo-tab-opere-associate>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="tab-2" title="Anagrafica del rilievo">
                    <ng-template ngbPanelContent>
                        <app-toolkit-rilievo-tab-anagrafica-rilievo [canEdit]="false" [formGroup]="criteriaForm"></app-toolkit-rilievo-tab-anagrafica-rilievo>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
    </div>
</div>